import { Star } from "lucide-react";

const GOOGLE_REVIEWS_URL =
  "https://maps.app.goo.gl/CH8SZi25aTY5fSnw9";

const GoogleIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden>
    <path
      fill="#FFC107"
      d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
    />
    <path
      fill="#FF3D00"
      d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
    />
    <path
      fill="#1976D2"
      d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
    />
  </svg>
);

/**
 * Variants:
 *  - "button": compact CTA pill with G icon + "Avaliar no Google"
 *  - "card":   bigger card showing 5★ rating + reviews count + CTA
 */
export const GoogleReviewButton = ({
  variant = "button",
  href = GOOGLE_REVIEWS_URL,
  inverted = false,
  className = "",
}) => {
  if (variant === "card") {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        data-testid="google-review-card"
        className={`inline-flex items-center gap-5 p-5 pr-7 border transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_-15px_rgba(218,165,32,0.4)] group ${
          inverted
            ? "bg-beige/10 border-gold/30 backdrop-blur-sm"
            : "bg-white border-ink/10 hover:border-gold"
        } ${className}`}
      >
        <GoogleIcon className="w-10 h-10 flex-shrink-0" />
        <div className="text-left">
          <div className="flex items-center gap-2 mb-0.5">
            <div className="flex gap-0.5 text-gold">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-current" />
              ))}
            </div>
            <span className={`text-sm font-medium tabular-nums ${inverted ? "text-beige" : "text-ink"}`}>5.0</span>
          </div>
          <p className={`text-xs ${inverted ? "text-beige/70" : "text-ink/60"}`}>
            4.976 avaliações <span className="text-gold-dark group-hover:underline">no Google →</span>
          </p>
        </div>
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="google-review-btn"
      className={`inline-flex items-center gap-3 bg-white border border-ink/10 px-5 py-3 transition-all duration-300 hover:border-gold hover:shadow-[0_10px_30px_-10px_rgba(218,165,32,0.4)] hover:-translate-y-0.5 group ${className}`}
    >
      <GoogleIcon className="w-5 h-5" />
      <div className="text-left">
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-medium text-ink">5.0</span>
          <div className="flex gap-0.5 text-gold">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-3 h-3 fill-current" />
            ))}
          </div>
        </div>
        <p className="text-[10px] uppercase tracking-[0.15em] text-ink/60 group-hover:text-gold transition-colors">
          Ver no Google
        </p>
      </div>
    </a>
  );
};

export default GoogleReviewButton;
